import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const InsufficientPlanModal = ({ requiredPlan = 'Higher Tier', onClose }) => {
    const navigate = useNavigate();

    const handleUpgrade = () => {
        onClose(); // Close the modal first
        navigate('/account', { state: { scrollTo: 'plans' } }); // Navigate to account page and pass scroll state
    };

    return (
        <div className="text-center">
            {/* Icon */}
            <motion.div
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.1, type: 'spring', stiffness: 150 }}
                className="mx-auto mb-6 w-20 h-20 rounded-full bg-gradient-to-br from-dark-500 to-dark-600 border-2 border-accent-red flex items-center justify-center shadow-lg"
            >
                <i className="fas fa-lock text-accent-red text-3xl"></i>
            </motion.div>

            {/* Title */}
            <motion.h2
                initial={{ y: -10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2 }}
                className="text-2xl font-bold mb-3 text-white"
            >
                Upgrade Required
            </motion.h2>

            {/* Message */}
            <motion.p
                initial={{ y: -10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3 }}
                className="text-gray-300 mb-6"
            >
                This feature requires the <span className="font-semibold text-accent-yellow">{requiredPlan}</span> plan or higher. Please upgrade your subscription to gain access.
            </motion.p>

            {/* Buttons */}
            <motion.div
                initial={{ y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.4 }}
                className="flex flex-col sm:flex-row gap-3 justify-center"
            >
                <button
                    onClick={handleUpgrade}
                    className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-accent-yellow to-accent-orange text-dark-800 rounded-xl hover:shadow-glow active:translate-y-0.5 transform-gpu transition font-medium flex items-center justify-center"
                >
                    <i className="fas fa-crown mr-2"></i> Upgrade Plan
                </button>
                <button
                    onClick={onClose}
                    className="w-full sm:w-auto px-6 py-3 bg-dark-500 hover:bg-dark-400 rounded-xl transition"
                >
                    Cancel
                </button>
            </motion.div>
        </div>
    );
};

export default InsufficientPlanModal;